<div class="py-2 px-2 py-md-5 px-md-5">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center mt-5">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <div class="row">
            <div class="col-md-6">
                <mat-card class="bg-white mat-elevation-z3">
                    <div class="d-flex flex-row-reverse link-secondary mx-2 mt-2" (click)="back()"
                         style="cursor: pointer" (keydown.backspace)="back()" role="button" aria-hidden="true">
                        <mat-icon aria-hidden="false" matTooltip="Zamknij" matTooltipPosition="below">close</mat-icon>
                    </div>
                    <div class="col-9 header">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-icon class="mx-1" color="primary">person</mat-icon>
                                Profil użytkownika
                            </mat-card-title>
                            <mat-card-subtitle>Informacje na temat użytkownika.</mat-card-subtitle>
                        </mat-card-header>
                    </div>
                    <mat-card-content>
                        <div class="pt-4">
                            <h4><i class="fa-regular fa-file-lines text-primary-color"></i> Imię:</h4>
                            <ul class="no-bullets">
                                <ng-container *ngIf="!editNameMode else editName">
                                    <li><h5>imię: <b class="text-primary-color">{{ user.name }}</b></h5></li>
                                    <li><h5>nazwa firmy: <b class="text-primary-color">{{ user.company_name }}</b></h5>
                                    </li>
                                    <div class="d-flex justify-content-end">
                                        <button class="mx-4" mat-stroked-button (click)="switchEditNameMode()">
                                            <i class="fa-solid fa-pen-to-square"></i> Edytuj
                                        </button>
                                    </div>
                                </ng-container>
                                <ng-template #editName>
                                    <app-user-form [user]="user" #data></app-user-form>
                                    <app-save-button
                                        [invalid]="data.userNameForm.invalid"
                                        (closeForm)="switchEditNameMode()"
                                        (save)="updateUserType()"
                                        [addMode]="false">
                                    </app-save-button>
                                </ng-template>
                            </ul>
                            <div class="pb-4">
                                <h4>
                                    <mat-icon color="primary">manage_accounts</mat-icon>
                                    Ustawienia:
                                </h4>
                                <ul class="no-bullets">
                                    <li><h5>e-mail: <b class="text-primary-color">{{ user.email }}</b></h5></li>
                                    <li><h5>regulamin: <b class="text-primary-color">{{ user.regulations }}</b></h5>
                                    </li>
                                    <li><h5>potwierdzony: <b class="text-primary-color">{{ user.confirmed }}</b></h5></li>
                                    <li><h5>aktywny: <b class="text-primary-color">{{ user.status }}</b></h5></li>
                                </ul>
                            </div>
                            <h4>
                                <mat-icon color="primary">security</mat-icon>
                                Typ:
                            </h4>
                            <ul class="no-bullets">
                                <ng-container *ngIf="!editTypeMode else editType">
                                    <li><h5><b class="text-primary-color">{{ user.type }}</b></h5></li>
                                    <div *ngIf="user.type !== 'admin'" class="d-flex justify-content-end">
                                        <button class="mx-4" mat-stroked-button (click)="switchEditTypeMode()">
                                            <i class="fa-solid fa-pen-to-square"></i> Edytuj
                                        </button>
                                    </div>
                                </ng-container>
                                <ng-template #editType>
                                    <div class="pt-2">
                                        <mat-form-field class="three-quarters-width" appearance="outline">
                                            <mat-label>Zmień typ:</mat-label>
                                            <mat-select [(value)]="userType">
                                                <mat-option [value]="'user'">użytkownik</mat-option>
                                                <mat-option [value]="'member'">pracownik</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <app-save-button
                                            [invalid]="false"
                                            (closeForm)="switchEditTypeMode()"
                                            (save)="updateUserType()"
                                            [addMode]="false">
                                        </app-save-button>
                                    </div>
                                </ng-template>
                            </ul>
                        </div>
                    </mat-card-content>
                    <mat-progress-bar mode="indeterminate" *ngIf="isUpdating" color="primary"></mat-progress-bar>
                </mat-card>
            </div>
        </div>
        <div class="col-md-6 text-center py-5">
            <button mat-stroked-button (click)="back()">
                <i class="fa-solid fa-rotate-left"></i> Zamknij
            </button>
        </div>
    </ng-template>
</div>
